import { useState } from "react";
import { ModalContainer, ModalWindow } from "../components/ui";
import { CitaProcessInformation } from "../features/citaProcessInformation/components/CitaProcessInformation";
import { DashboardTable } from "../features/processDashboard/components/DashboardTable";
import { FiltrosConsultaRespuesta } from "../components/FiltrosComponents";
import { FilterCitas, ShowFilters } from "../types";
import { PaginationButtons } from "../components/UtilitiesComponents/PaginationButtons";
import { formatDate } from "../utilities/formatDate";

export function ConfirmationProcessDashboard() {
    const [openModal, setOpenModal] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState<number | null>(null);
    const [filters, setFilters] = useState<FilterCitas>({
        fechaInicial: formatDate(new Date(new Date().setDate(new Date().getDate() - 2))),
        fechaFinal: formatDate(new Date()),
        respuesta: "0",
        sucursal: "0",
        doctor: "0",
        canal: "0"
    });
    const [pageNumber, setPageNumber] = useState<number>(1);

    const showFilters: ShowFilters = {
        fechas: true,
        sucursales: false,
        canales: false,
        respuestas: false,
        doctores: false,
    };

    return (
        <div>
            <div className="my-3">
                <FiltrosConsultaRespuesta
                    showFilters={showFilters}
                    filters={filters}
                    setFilters={setFilters}/>
            </div>

            <div>
                <DashboardTable
                    filters={filters}
                    pageNumber={pageNumber}
                    onClick={(value) => {
                        setSelectedAppointment(value.citaId);
                        setOpenModal(true);
                    }}/>
            </div>

            <div className="flex justify-center my-3">
                <PaginationButtons
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                    nextPage={true}/>
            </div>

            {openModal && selectedAppointment != null && (
            <ModalWindow>
                <ModalContainer onClose={() => setOpenModal(false)}>
                    <CitaProcessInformation citaId={selectedAppointment}/>
                </ModalContainer>
            </ModalWindow>
            )}
        </div>
    );
}
